class AnimateIn {
  constructor() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Prevent the animation from running if the user has requested reduced motion
    if (!prefersReducedMotion || prefersReducedMotion.matches) {
      document.body.className += ' is-ready-for-content';
      return;
    }

    this.video = document.getElementsByClassName('homepage-topper__animation--video')[0];
    this.calcPosition();
    this.showPage();
  }

  calcPosition() {
    const windowHeight = window.innerHeight;
    const videoHeight = this.video.offsetHeight;
    const videoOffset = this.video.getBoundingClientRect().top;

    const tempTransform = (windowHeight - videoHeight) * 0.5 - videoOffset - videoHeight * 0.1;

    if (tempTransform > 0) {
      this.video.style.setProperty('--translateY', `${tempTransform}`);
    }
  }

  zeroOutTransform() {
    this.video.style.setProperty('--translateY', `0`);
  }

  showPage() {
    if (document.documentElement.scrollTop > 0) {
      document.body.className += ' is-ready-for-content';
      this.zeroOutTransform();
    } else {
      setTimeout(() => {
        document.body.className += ' is-ready-for-content';
        this.zeroOutTransform();
      }, 2100);
    }
  }
}

export default AnimateIn;
